import UserInfo from '@/models/UserInfo/UserInfo';

export default class UserInfoFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.userName = '';
		this.firstName = '';
		this.lastName = '';
		this.password = '';
		this.email = '';
		this.userLevel = '';
		this.approvalGroupId  = '';
		this.approvalGroupName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			userName : '0',
			firstName : '0',
			lastName : '0',
			password : '0',
			email : '0',
			userLevel : '0',
			approvalGroupId : '0',
			approvalGroupName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}